import { t as e } from "./createApiQueryClient-DwmsEdyU.js";
import { r as t } from "./createEndpoints-BYEC3FIA.js";
//#region src/clients/dashboard/createDashboardApiClient.ts
var n = (e) => async (t, n) => {
	if (e.invalidateQueries?.length) {
		let r = await e.fetchFunction(t, n);
		if (r.error) {
			let e = /* @__PURE__ */ Error("Failed to fetch");
			throw Object.assign(e, { res: r.res }), e;
		}
		return r;
	}
	let r = await e.apiQueryClient.fetchQuery({
		queryFn: async () => {
			let r = await e.fetchFunction(t, n);
			if (r.error) {
				let e = /* @__PURE__ */ Error("Failed to fetch");
				throw Object.assign(e, { res: r.res }), e;
			}
			return r;
		},
		queryKey: [
			...e.queryKey,
			...t ? [t] : [],
			"legacy"
		]
	});
	return e.apiQueryClient.setQueryData([...e.queryKey, ...t ? [t] : []], r.data), e.apiQueryClient.removeQueries({ queryKey: [
		...e.queryKey,
		...t ? [t] : [],
		"legacy"
	] }), r;
};
function r(e, t, n) {
	let r = e(t), i = e.demoModeHandler;
	return !n || !i ? r : (e, t) => {
		let n = i(e);
		return n === void 0 ? r(e, t) : n;
	};
}
var i = (i) => {
	let a = {}, o = (e) => (t) => Object.entries(i.endpoints).forEach(([o, s]) => {
		let c = r(s, t, e.isDemoEnv), l = [
			...e.baseQueryKey ? [e.baseQueryKey] : [],
			..."queryKey" in s ? s.queryKey : ["No query key found"],
			i.version
		], u = [];
		"invalidateQueries" in s && (u = (s.invalidateQueries ?? []).map((e) => [...Array.isArray(e) ? e : [e]]));
		let d = async (t, r) => {
			try {
				let i = await n({
					apiQueryClient: e.apiQueryClient,
					fetchFunction: c,
					queryKey: l,
					invalidateQueries: u
				})(t, r);
				return await Promise.all(u.map((t) => {
					let n = typeof t == "string" ? t : t.join(".");
					e.apiQueryClient.invalidateQueries({ predicate: (e) => e.queryKey.join(".").includes(n) });
				})), i;
			} catch (e) {
				return {
					error: !0,
					res: e && typeof e == "object" && "res" in e ? e.res : { status: 500 },
					data: null
				};
			}
		};
		Object.assign(d, {
			request: (e, t) => c(e, t),
			queryKey: l,
			mocking: s.mocking,
			method: s.method,
			version: i.version,
			invalidateQueries: u,
			..."paramQueryKeyTransform" in s ? { paramQueryKeyTransform: s.paramQueryKeyTransform } : {}
		}), a[o] = d;
	}, {}), s = (n) => {
		let r = n.isDemoEnv ? t(n.apiOrigin, { headers: {
			"Sequence-Version": i.version,
			"Sequence-Audience": "internal",
			Authorization: `Basic ${n.demoApiKey}`,
			...n.defaultHeaders ?? {}
		} }) : t(n.apiOrigin, { headers: {
			"Sequence-Version": i.version,
			"Sequence-Audience": "internal",
			...n.defaultHeaders ?? {}
		} });
		o({
			apiQueryClient: n.apiQueryClient ?? e(),
			baseQueryKey: n.baseQueryKey,
			isDemoEnv: n.isDemoEnv ?? !1
		})(r);
	};
	return s({ apiOrigin: "" }), a.initialize = s, a;
}, a = "customers", o = "customer-aliases", s = "customers-csv-download", c = "customer-custom-property-keys";
//#endregion
//#region src/utils/sanitiseRequestBody.ts
function l(e, t) {
	return typeof e == "string" ? e.trim() : Array.isArray(e) ? e.map((e) => l(e, t)) : typeof e == "object" && e ? Object.fromEntries(Object.entries(e).map(([e, n]) => [e, t ? t.includes(e) ? l(n) : n : l(n)])) : e;
}
//#endregion
export { c as a, o as i, a as n, i as o, s as r, l as t };

//# sourceMappingURL=sanitiseRequestBody-Dm5hzjxP.js.map